import type { AppendixTargetAsset } from '@libs/enums';
import type { ItemAttributes, ItemNames, OrEmpty } from '@ps-smart-cp/ppfw-client';
import { Characters, ItemName, Locale, SingleValue } from '@ps-smart-cp/ppfw-client';

/**
 * 法人税申告
 */
interface Schema {
  /**
   * 別表対象区分
   */
  appxTgtClass: OrEmpty<AppendixTargetAsset>;
  /**
   * 期首繰越償却超過額
   */
  carryForwardOverDepreciation: string;
  /**
   * 期首繰越償却不足額
   */
  carryForwardUnderDepreciation: string;
}

interface Record {
  appxTgtClass: string;
  carryForwardOverDepreciation: string;
  carryForwardUnderDepreciation: string;
}

const attributes = {
  appxTgtClass: SingleValue.shortValue(),
  carryForwardOverDepreciation: Characters.preset.freeFormat(),
  carryForwardUnderDepreciation: Characters.preset.freeFormat(),
} satisfies ItemAttributes<Schema>;

const names = {
  appxTgtClass: ItemName.of([Locale.ja, '別表対象区分'], [Locale.en, 'Appendix Target Classification']),
  carryForwardOverDepreciation: ItemName.of([Locale.ja, '期首繰越償却超過額']),
  carryForwardUnderDepreciation: ItemName.of([Locale.ja, '期首繰越償却不足額']),
} satisfies ItemNames<Schema>;

const corporateTaxDeclaration = {
  names,
  attributes,
};

interface CorporateTaxDeclaration {
  schema: Schema;
  record: Record;
}

export { corporateTaxDeclaration };
export type { CorporateTaxDeclaration };
